import { Injectable } from '@angular/core';
import { AuthProvider } from '../../providers';

@Injectable({
  providedIn: 'root'
})
export class BasketService {
  constructor(private readonly authService: AuthProvider) {}

  /** Get the amount/sum of all items in the basket */
  get amount(): number {
    return this.authService.cookies(true).basket?.basketAmount ?? 0;
  }

  /** Get the counter of items in the basket */
  get count(): number {
    return this.authService.cookies(true).basket?.basketCount ?? 0;
  }

  /** Get the counter of items in the inquiry list (RequestList basket) */
  get requestListCount(): number {
    return this.authService.cookies(true).basket?.requestListCount ?? 0;
  }

  /** Check if the user is a guest */
  get isGuest(): boolean {
    return this.authService.cookies(true)?.basket?.guest ?? false;
  }
}
